import { render, staticRenderFns } from "./NewProcPriceModal.vue?vue&type=template&id=531923eb"
import script from "./NewProcPriceModal.vue?vue&type=script&lang=js"
export * from "./NewProcPriceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports